import { useSyncExternalStore } from 'react';
import { getLocale, subscribeLocale, t } from './index';

/**
 * Reactive translation. Re-renders the component when the locale changes, so a
 * language switcher (Phase 8) updates the whole tree without prop-drilling.
 * Returns the same `t` signature as the pure lookup.
 */
export function useT(): { t: typeof t; locale: string } {
  const locale = useSyncExternalStore(subscribeLocale, getLocale, getLocale);
  return { t, locale };
}
